import { Link } from '@reach/router';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  FooterType,
  NavigationFooterData,
  selectFooter,
  UpdateProfileFooterData,
} from 'reducers/footer';
import LinkedinIcon from '../../../assets/apply.clevry/Icon_Social_01.png';
import LinkedinIconYellow from '../../../assets/apply.clevry/Icon_Social_01_Yellow.png';
import LinkedinIconWhite from '../../../assets/apply.clevry/Icon_Social_01_White.png';
import LinkedinIconBlack from '../../../assets/apply.clevry/Icon_Social_01_Black.png';
import TwitterIcon from '../../../assets/apply.clevry/Icon_Social_02.png';
import TwitterIconYellow from '../../../assets/apply.clevry/Icon_Social_02_Yellow.png';
import TwitterIconWhite from '../../../assets/apply.clevry/Icon_Social_02_White.png';
import TwitterIconBlack from '../../../assets/apply.clevry/Icon_Social_02_Black.png';
import FacebookIcon from '../../../assets/apply.clevry/Icon_Social_04.png';
import FacebookIconYellow from '../../../assets/apply.clevry/Icon_Social_04_Yellow.png';
import FacebookIconWhite from '../../../assets/apply.clevry/Icon_Social_04_White.png';
import FacebookIconBlack from '../../../assets/apply.clevry/Icon_Social_04_Black.png';
import InstagramIcon from '../../../assets/apply.clevry/Icon_Social_05.png';
import InstagramIconYellow from '../../../assets/apply.clevry/Icon_Social_05_Yellow.png';
import InstagramIconWhite from '../../../assets/apply.clevry/Icon_Social_05_White.png';
import InstagramIconBlack from '../../../assets/apply.clevry/Icon_Social_05_Black.png';
import { NavigationFooter } from './NavigationFooter';
import { UpdateProfileFooter } from './UpdateProfileFooter';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';
import { selectAccessibilityData } from 'reducers/accessibility';
import { selectAccessibilityStatement, selectAccessibilityStatementProjectId } from 'reducers/landingPage';
import { selectPrivacyPolicy } from 'reducers/landingPage';
import { paths } from 'appConstants';

export const FooterSocials: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });
  const accessibilityData = useSelector(selectAccessibilityData);  

  const socialIconToShow = (accessibility_str: any, icons_list: any) => {
    if(accessibility_str === "SiteAccessibilityYellow"){
      return icons_list[1];
    } else if (accessibility_str === "SiteAccessibilityWhite") {
      return icons_list[2];
    } else if (accessibility_str === "SiteAccessibilityBlack") {
      return icons_list[3];
    } else {
      return icons_list[0];
    }
  };

  return (
    <div className="Socials">
      <a
        href="https://www.linkedin.com/company/clevry/"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={socialIconToShow(accessibilityData.siteAccessibilityColour, [LinkedinIcon, LinkedinIconYellow, LinkedinIconWhite, LinkedinIconBlack])} alt={t('SSCandidate_Footer_Alt_LinkedIn_Icon')} />
      </a>
      <a
        href="https://twitter.com/ClevryGroup"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={socialIconToShow(accessibilityData.siteAccessibilityColour, [TwitterIcon, TwitterIconYellow, TwitterIconWhite, TwitterIconBlack])} alt={t('SSCandidate_Footer_Alt_Twitter_Icon')} />
      </a>
      <a
        href="https://www.instagram.com/clevry.group/"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={socialIconToShow(accessibilityData.siteAccessibilityColour, [InstagramIcon, InstagramIconYellow, InstagramIconWhite, InstagramIconBlack])}
          alt={t('SSCandidate_Footer_Alt_Instagram_Icon')}
        />
      </a>
      <a
        href="https://www.facebook.com/clevryCOM"
        className="Social"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={socialIconToShow(accessibilityData.siteAccessibilityColour, [FacebookIcon, FacebookIconYellow, FacebookIconWhite, FacebookIconBlack])} alt={t('SSCandidate_Footer_Alt_Facebook_Icon')} />
      </a>
    </div>
  );
};

export const FooterCopyright: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });

  return (
    <div className="FooterCopyright">
      <p className="Copyright">
        <span>
          {t('SSCandidate_Footer_Copyright', {
            val1: new Date().getFullYear(),
          })}

          {/* OLD: */}
          {/* {t('SSCandidate_Footer_Copyright')} &#169;{new Date().getFullYear()}{' '}
          {t('SSCandidate_Footer_Clevry_Rights')} */}
        </span>
      </p>
    </div>
  );
};

export const FooterCopyrightRight: React.FC = () => (
  <div className="FooterCopyrightRight">
    <p className="Copyright">
      <span>
        Copyright &#169;{new Date().getFullYear()} Clevry. All rights reserved.
      </span>
    </p>
  </div>
);

export const FooterLegalLinks: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });
  
  const accessibilityStatement = useSelector(selectAccessibilityStatement); 
  const privacyPolicy = useSelector(selectPrivacyPolicy);   
  
  const selectedAccessibilityStatement = accessibilityStatement ?
    accessibilityStatement :
    null;  

  return (
    <>
      <a
        className="FooterLink"
        href="/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SSCandidate_Footer_Terms_And_Conditions')}
      </a>

      <a
        className="FooterLink"
        href={privacyPolicy ? paths.privacyPolicy.url : 'https://www.clevry.com/en/privacy-policy/'}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SSCandidate_Footer_Privacy_Policy')}
      </a>

      <a
        className="FooterLink"
        href="https://www.clevry.com/en/cookie-policy/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SSCandidate_Footer_Cookies_Policy')}
      </a>

      {selectedAccessibilityStatement && 
        <a
          className="FooterLink"
          href="/accessibility-statement"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('SSCandidate_Footer_Accessibility_Statement')}
        </a>
      }     
    </>
  );
};

export const LoggedInFooterLegalLinks: React.FC = () => {
  const { t } = useTranslation('Footer', { i18n });
  
  const accessibilityStatement = useSelector(selectAccessibilityStatement);  
  const accessibilityStatementProjectId = useSelector(selectAccessibilityStatementProjectId);  
  const privacyPolicy = useSelector(selectPrivacyPolicy);  

  const selectedAccessibilityStatement = accessibilityStatement ?
    accessibilityStatement :
    null; 
    
  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';    

  return (
    <>
      {currentWebskin === "SSCL-MoJ" &&
        <a
          className="FooterLink"
          href={privacyPolicy ? paths.privacyPolicy.url : 'https://www.clevry.com/en/privacy-policy/'}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('SSCandidate_Footer_Privacy_Policy')}
        </a>      
      }
      {selectedAccessibilityStatement && 
        <a
          className="FooterLink"
          href={accessibilityStatementProjectId ? ("/accessibility-statement/" + accessibilityStatementProjectId) : "/accessibility-statement"}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('SSCandidate_Footer_Accessibility_Statement')}
        </a>
      }     
    </>
  );
};

interface FooterProps {
  isThemed: boolean;
}

const Footer: React.FC<FooterProps> = ({ isThemed }) => {
  const { data, footerType } = useSelector(selectFooter);

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';   

  // Don't include NavigationFooter in Footer div as it doesn't obey the same
  // syling rules.
  if (footerType === FooterType.NAVIGATION_FOOTER) {
    return (
      <div className={`NavigationFooterContainer  ${isThemed ? 'Themed' : ''}`}>
        <NavigationFooter {...(data as NavigationFooterData)} />
      </div>
    );
  }
  if (footerType === FooterType.NONE) {
    return null;
  }

  return (
    <footer className={`Footer ${isThemed ? 'Themed' : ''} WidthContent`}>
      {footerType === FooterType.LOGGED_IN ? (
        <div className="FooterLinks LoggedInFooter">
          <div className="LeftContainer">
            <FooterSocials />
            <LoggedInFooterLegalLinks />
          </div>
          <FooterCopyright />
        </div>
      ) : footerType === FooterType.COPYRIGHT_ONLY ? (
        <FooterCopyright />
      ) : footerType === FooterType.COPYRIGHT_ONLY_RIGHT ? (
        <FooterCopyrightRight />
      ) : footerType === FooterType.PUBLIC_ALL_ELEMENTS ? (
        <>
          <div className="FooterLinks">
            <FooterSocials />
            <FooterLegalLinks />
          </div>
          <div className="FooterRight">
            <FooterCopyright />
          </div>
        </>
      ) : footerType === FooterType.UPDATE_PROFILE ? (
        <UpdateProfileFooter {...(data as UpdateProfileFooterData)} />
      ) : null}
    </footer>
  );
};

export { Footer };
